import React from 'react'

import SignalIntentCalculator from './SignalIntentCalculator'

const SavingInterestCalculatorBlock = () => {
  return <SignalIntentCalculator Guid='7cd9b4aa-e9d0-4f4e-a47b-ca401d75fa20' />
}

export default React.memo(SavingInterestCalculatorBlock)
